import { trpc } from "../../main/components/trpc.ts";
import type { TherapeuticChoicesFeesSettings } from "cadendar-shared";

export const useTherapeuticChoicesFees = () => {
  const utils = trpc.useUtils();

  const settingsQuery = trpc.therapeuticChoicesFees.get.useQuery(undefined, {
    refetchOnWindowFocus: false,
  });

  const saveMutation = trpc.therapeuticChoicesFees.save.useMutation({
    onSuccess: async () => {
      await utils.therapeuticChoicesFees.get.invalidate();
    },
  });

  const saveSettings = async (settings: TherapeuticChoicesFeesSettings) => {
    return saveMutation.mutateAsync(settings);
  };

  return {
    settings: settingsQuery.data,
    isLoading: settingsQuery.isLoading,
    error: settingsQuery.error,
    saveSettings,
    isSaving: saveMutation.isPending,
    saveError: saveMutation.error,
  };
};
